module.exports = __webpack_public_path__ + "static/img/app-sub-img03@m.8fdc15a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/app-sub-img03@m.png
// module id = UrWM
// module chunks = 0